import React, { useState, useEffect } from "react";
import Sidebar from "../../Components/Sidebar/Sidebar";
import { Form } from "react-bootstrap";
import "../../assets/css/admin.css";
import DashboardNav from "../../Components/DashboardHeader/DashboardNav";
import { Link, useParams } from "react-router-dom";
import Dropdown from "../DashboardComponents/Dropdown/Dropdown";
import DropdownDot from "../DashboardComponents/Dropdown Customer/DropdownDot";
import { AiFillCloseCircle, AiFillCheckCircle } from "react-icons/ai";
import HeaderAdmin from "../../Components/HeaderAdmin/Header";
import CustomSelectIcon from "./SelectBarview";
import { updateFittingStage, addIron, getFittingById, updateFitting, getclubfollowactivityapi, getremoteInquirydataApi } from "../../Api/iron"
import { updateUser, getErrorByField, getUserById } from './../../Api/auth'
import { Spinner } from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';
import Right from "../../Components/Icons/Right";
import Worang from "../../Components/Icons/Worang";
import { IoIosArrowBack } from "react-icons/io";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar, Mousewheel } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import { FaPlay, FaCheck } from "react-icons/fa";
import { Accordion } from "react-bootstrap";
import { FaAngleUp } from "react-icons/fa";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import VideoUpload from "../DashboardComponents/ClubFitting Video view/VideoUpload";
import VideoUpload2 from "../DashboardComponents/ClubFitting Video view/VideoUpload2";
import IronsData from "../DashboardComponents/Clubfitting IronsData view/IronsData";
import ImageUpload from "../DashboardComponents/ClubFitting ImageUpload view/ImageUpload";
function FollowView() {

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    const [edittrue, setEdittrue] = useState(false);
    const [firstvideo, setFirstVideo] = useState(null);
    const [secondvideo, setSecondVideo] = useState(null);
    const params = useParams();

    const [isOpen, setIsOpen] = useState(false);

    const [stagenotes, setStageNotes] = useState("");
    const [updatestageapicall, setUpdatestageapicall] = useState(false);
    const [clubfollowactivity, setClubFollowActivity] = useState([]);

    const userData = localStorage.getItem("user");
    const userJson = JSON.parse(userData);
    let roleId;
    if (userData) {
        roleId = userJson.user?.role_id
    } else {
        roleId = null
    }

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const soleDesign = [
        { value: '1', label: 'High', icon: '1' },
        { value: '2', label: 'Medium', icon: '2' },
        { value: '3', label: 'Low', icon: '3' }
    ];

    const lieAngle = [
        { value: '1', label: 'Upright', icon: '1' },
        { value: '2', label: 'Standard', icon: '2' },
        { value: '3', label: 'Flat', icon: '3' }
    ];

    const shaftWeight = [
        { value: '1', label: 'Heavy', icon: '1' },
        { value: '2', label: 'Medium', icon: '2' },
        { value: '3', label: 'Light', icon: '3' }
    ];

    const shaftFlex = [
        { value: '1', label: 'Hard', icon: '1' },
        { value: '2', label: 'Medium', icon: '2' },
        { value: '3', label: 'Soft', icon: '3' }
    ];

    const shaftProfile = [
        { value: '1', label: 'High', icon: '1' },
        { value: '2', label: 'Medium', icon: '2' },
        { value: '3', label: 'Low', icon: '3' }
    ];

    const gripSize = [
        { value: '1', label: 'Large', icon: '1' },
        { value: '2', label: 'Medium', icon: '2' },
        { value: '3', label: 'Small', icon: '3' }
    ];

    const shaftLength = [
        { value: '1', label: 'Long', icon: '1' },
        { value: '2', label: 'Medium', icon: '2' },
        { value: '3', label: 'Short', icon: '3' }
    ];

    const [notes, setNotes] = useState('');
    const handleInitCustomerClub = (name, option) => {
        console.log("handleInitCustomerClub", name + " === " + option.value);
        setInitCustomerClub(prevState => ({
            ...prevState,
            [name]: option
        }));
    };

    const handleInitCustomerTesting = (name, option) => {
        console.log("handleInitCustomerTesting", name + " === " + option.value);
        setInitCustomerTesting(prevState => ({
            ...prevState,
            [name]: option
        }));
    };

    const [initCustomerClub, setInitCustomerClub] = useState({
        soledesign: { value: '0', label: 'Select Bounce', icon: '0' },
        lieangle: { value: '0', label: 'Select Angle', icon: '0' },
        shaftweight: { value: '0', label: 'Select Weight', icon: '0' },
        shaftflex: { value: '0', label: 'Select Flex', icon: '0' },
        shaftprofile: { value: '0', label: 'Select Profile', icon: '0' },
        gripsize: { value: '0', label: 'Select SiZe', icon: '0' },
        shaftlength: { value: '0', label: 'Select Length', icon: '0' }
    });

    const [initCustomerTesting, setInitCustomerTesting] = useState({
        testingsoledesign: { value: '0', label: 'Select Bounce', icon: '0' },
        testinglieangle: { value: '0', label: 'Select Angle', icon: '0' },
        testingshaftweight: { value: '0', label: 'Select Weight', icon: '0' },
        testingshaftflex: { value: '0', label: 'Select Flex', icon: '0' },
        testingshaftprofile: { value: '0', label: 'Select Profile', icon: '0' },
        testinggripsize: { value: '0', label: 'Select SiZe', icon: '0' },
        testingshaftlength: { value: '0', label: 'Select Length', icon: '0' }

    });

    const SettingIcon = (
        <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
                <path d="M2205 5106 c-36 -15 -83 -68 -90 -99 -3 -12 -17 -74 -33 -137 l-28 -115 -60 -18 c-230 -69 -383 -131 -537 -219 l-88 -50 -103 61 c-146 87 -176 97 -229 81 -35 -10 -81 -51 -270 -238 -243 -242 -273 -282 -261 -346 3 -20 31 -77 61 -128 95 -160 91 -136 35 -236 -88 -157 -162 -336 -207 -497 -13 -48 -28 -91 -32 -95 -4 -4 -66 -21 -137 -38 -131 -31 -163 -46 -200 -96 -20 -27 -21 -40 -21 -376 0 -338 1 -349 21 -377 36 -48 76 -67 208 -97 105 -24 129 -33 136 -50 4 -12 28 -84 53 -161 47 -146 101 -275 114 -275 4 0 163 159 353 353 l346 352 -14 125 c-52 493 179 979 594 1252 385 253 851 295 1281 117 249 -104 485 -314 628 -559 188 -322 232 -730 119 -1091 -103 -331 -357 -630 -666 -786 -226 -114 -515 -168 -765 -142 l-115 12 -351 -351 -351 -351 69 -32 c57 -26 234 -87 365 -127 22 -7 28 -21 57 -142 34 -138 48 -168 97 -204 27 -20 40 -21 376 -21 336 0 349 1 376 21 50 37 66 70 98 205 l31 134 60 18 c228 68 384 131 538 219 l87 50 123 -71 c67 -38 135 -73 150 -77 62 -15 101 14 344 258 301 303 294 281 162 504 l-61 103 50 88 c88 154 151 310 219 538 l18 60 134 32 c137 32 168 47 205 97 20 27 21 40 21 376 0 336 -1 349 -21 376 -37 50 -68 65 -205 97 l-134 32 -18 60 c-68 228 -131 384 -219 538 l-50 88 61 103 c132 223 139 201 -162 504 -243 244 -282 273 -344 258 -15 -4 -83 -39 -150 -77 l-123 -71 -87 50 c-154 88 -310 151 -538 219 l-60 18 -31 134 c-32 135 -48 168 -98 205 -26 20 -42 21 -364 23 -265 2 -344 0 -367 -11z" />
                <path d="M2435 3603 c-641 -82 -1060 -712 -883 -1327 l20 -69 -749 -751 c-700 -701 -751 -755 -777 -814 -79 -181 -45 -374 88 -508 134 -133 327 -167 508 -88 59 26 113 77 814 777 l752 749 48 -15 c112 -35 162 -42 309 -42 131 1 164 4 260 29 237 60 421 178 558 359 157 205 237 459 223 709 -11 212 -49 304 -136 326 -79 20 -97 8 -320 -213 -113 -111 -218 -209 -235 -217 -83 -43 -196 -43 -278 -2 -150 76 -207 276 -120 418 14 23 112 129 218 236 210 213 223 231 203 310 -14 56 -62 95 -133 110 -133 28 -269 36 -370 23z" />
            </g>
        </svg>
    );

    const Contact = (
        <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
                <path d="M967 4756 c-21 -8 -64 -32 -95 -54 -31 -21 -190 -130 -352 -242 -162 -111 -297 -204 -299 -206 -10 -9 -32 -132 -42 -239 -54 -580 268 -1511 805 -2324 195 -295 366 -509 591 -740 288 -296 555 -484 817 -576 l77 -27 386 183 c228 109 403 198 426 218 22 18 49 52 61 75 28 55 36 159 15 208 -30 72 -410 720 -439 749 -64 63 -165 91 -247 69 -24 -6 -142 -65 -261 -131 -120 -65 -223 -119 -230 -119 -31 0 -260 263 -405 466 -174 243 -399 656 -504 923 -44 112 -121 354 -121 381 0 4 101 69 225 144 142 87 235 150 254 174 56 67 76 173 48 252 -15 40 -388 689 -424 736 -55 73 -198 113 -286 80z" />
                <path d="M1906 4008 c25 -68 29 -192 10 -267 -9 -35 -15 -65 -14 -66 2 -1 259 -177 572 -391 313 -214 573 -388 577 -387 6 2 1111 758 1659 1135 24 16 -56 17 -1397 17 l-1422 1 15 -42z" />
                <path d="M4085 3313 c-467 -321 -883 -606 -924 -633 -125 -84 -61 -115 -775 375 -340 233 -624 421 -630 418 -6 -4 -31 -21 -56 -38 -25 -18 -96 -62 -157 -100 -62 -37 -113 -71 -113 -76 0 -5 19 -60 41 -122 107 -290 305 -660 502 -937 74 -103 196 -257 228 -287 l24 -21 165 89 c122 66 183 93 238 105 126 28 265 3 373 -67 87 -56 148 -134 279 -363 l125 -217 700 3 c637 3 703 5 731 20 44 24 91 81 103 125 13 44 15 2281 3 2299 -4 7 -326 -208 -857 -573z" />
            </g>
        </svg>
    );

    const Calculation = (
        <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
                <path d="M706 4994 c-59 -21 -98 -56 -131 -115 l-30 -54 -3 -2097 -2 -2098 382 0 c211 0 534 3 718 6 l335 7 -178 353 -177 354 2 1517 c3 1498 3 1518 23 1551 11 18 36 43 55 55 34 21 47 22 325 25 285 3 291 2 335 -20 33 -17 51 -35 68 -68 l22 -44 0 -1511 -1 -1510 -177 -352 -178 -353 614 0 c663 0 666 0 676 -53 3 -12 7 -80 10 -152 5 -146 16 -182 72 -245 47 -52 106 -74 184 -68 79 6 133 43 172 117 l28 53 0 629 0 629 -478 0 c-536 0 -550 2 -623 67 -22 20 -50 55 -62 77 l-22 41 -3 1314 c-3 1459 -6 1378 64 1459 20 24 55 53 78 65 41 22 47 22 539 25 l497 3 0 112 c0 129 -14 169 -76 229 -76 73 35 68 -1573 67 -1229 0 -1452 -3 -1485 -15z m629 -1049 c32 -31 34 -96 5 -125 -19 -19 -33 -20 -259 -20 -132 0 -247 3 -256 6 -19 8 -45 55 -45 84 0 12 13 35 29 51 l29 29 237 0 236 0 24 -25z m0 -890 c35 -34 34 -86 -1 -114 -25 -20 -39 -21 -253 -21 -243 0 -263 4 -290 52 -12 20 -13 34 -6 55 18 49 40 53 293 53 l233 0 24 -25z m6 -884 c26 -32 24 -77 -6 -106 l-24 -25 -235 0 -234 0 -31 26 c-17 14 -31 36 -31 48 0 28 26 65 54 76 11 5 126 8 254 7 232 -2 234 -2 253 -26z m-35 -861 c38 -15 53 -38 54 -82 0 -28 -6 -41 -26 -57 -25 -20 -39 -21 -260 -21 l-232 0 -31 26 c-49 41 -38 103 22 129 39 17 430 21 473 5z" />
                <path d="M2860 4410 c-20 -20 -20 -33 -20 -1330 0 -1297 0 -1310 20 -1330 20 -20 33 -20 1075 -20 1042 0 1055 0 1075 20 20 20 20 33 20 1333 0 1260 -1 1315 -18 1330 -17 16 -106 17 -1075 17 -1044 0 -1057 0 -1077 -20z m1831 -380 c16 -22 19 -48 20 -230 l1 -204 -27 -23 -27 -23 -725 2 -725 3 -19 24 c-17 21 -19 41 -19 232 0 196 1 210 20 229 20 20 31 20 751 18 l732 -3 18 -25z m-1181 -910 c31 -31 36 -68 13 -98 -20 -26 -24 -27 -137 -30 -126 -3 -151 4 -167 45 -11 31 4 78 30 93 9 5 67 10 129 10 98 0 114 -2 132 -20z m550 10 c10 -5 24 -26 30 -46 11 -32 10 -39 -7 -63 -20 -25 -23 -26 -145 -29 -115 -2 -126 -1 -143 18 -27 30 -25 88 4 111 20 16 41 19 133 19 60 0 118 -4 128 -10z m560 0 c10 -5 24 -26 30 -46 11 -32 10 -39 -7 -63 -20 -25 -23 -26 -145 -29 -118 -2 -125 -1 -145 20 -34 36 -34 77 -1 108 19 18 35 20 136 20 62 0 122 -4 132 -10z m-1107 -498 c9 -10 20 -32 23 -49 5 -26 1 -37 -19 -57 -25 -25 -31 -26 -136 -26 -60 0 -117 3 -126 6 -24 10 -46 60 -39 89 11 46 38 55 165 55 99 0 118 -3 132 -18z m542 12 c18 -7 45 -55 45 -79 0 -9 -11 -27 -25 -40 -23 -24 -30 -25 -138 -25 -136 0 -161 12 -161 75 0 63 25 75 154 75 60 0 116 -3 125 -6z m565 -4 c25 -13 41 -65 30 -95 -14 -37 -41 -45 -159 -45 -100 0 -112 2 -135 23 -36 32 -39 74 -6 107 18 18 33 20 136 20 63 0 124 -4 134 -10z m-1117 -500 c27 -22 41 -61 32 -91 -12 -35 -57 -49 -164 -49 -90 0 -102 2 -127 23 -20 17 -27 33 -27 57 0 24 7 40 27 57 25 21 37 23 130 23 88 0 107 -3 129 -20z m555 4 c51 -35 48 -109 -4 -133 -14 -6 -70 -11 -125 -11 -98 0 -101 1 -130 29 -16 16 -29 39 -29 51 0 12 13 35 29 51 29 28 32 29 133 29 79 0 109 -4 126 -16z m564 -4 c46 -36 42 -106 -9 -129 -33 -15 -212 -14 -243 2 -38 19 -54 60 -38 94 20 42 52 53 164 53 86 0 105 -3 126 -20z" />
                <path d="M1780 3490 l0 -840 250 0 250 0 0 840 0 840 -250 0 -250 0 0 -840z" />
                <path d="M1780 1930 l0 -540 122 -245 c68 -135 125 -245 128 -245 3 0 60 110 128 245 l122 245 0 540 0 540 -250 0 -250 0 0 -540z" />
                <path d="M80 388 c0 -46 5 -100 11 -122 14 -51 91 -128 145 -144 32 -9 391 -12 1551 -12 l1510 0 -31 61 c-27 55 -30 72 -34 180 l-4 119 -1574 0 -1574 0 0 -82z" />
            </g>
        </svg>
    );

    const Calculator = (
        <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
                <path d="M78 5099 c-23 -12 -46 -35 -58 -59 -20 -39 -20 -55 -20 -2315 0 -2261 0 -2276 20 -2315 13 -26 34 -47 60 -60 39 -20 53 -20 1153 -18 l1114 3 -68 95 c-161 224 -261 466 -311 750 -17 98 -17 422 0 520 8 41 26 125 42 185 173 661 741 1169 1418 1265 l82 12 0 920 c0 901 0 920 -20 958 -13 26 -34 47 -60 60 -39 20 -55 20 -1677 20 -1611 -1 -1639 -1 -1675 -21z m2712 -649 c26 -13 47 -34 60 -60 19 -37 20 -58 20 -470 0 -412 -1 -433 -20 -470 -13 -26 -34 -47 -60 -60 -39 -20 -57 -20 -1031 -20 l-991 0 -40 22 c-79 45 -78 40 -78 530 1 487 0 478 76 524 l39 24 993 0 c975 0 993 0 1032 -20z m-1680 -1440 c45 -23 80 -80 80 -130 0 -50 -35 -107 -80 -130 -32 -16 -59 -20 -150 -20 -134 0 -178 17 -210 80 -38 74 -16 153 56 196 35 21 51 24 152 24 93 0 120 -3 152 -20z m800 0 c45 -23 80 -80 80 -130 0 -50 -35 -107 -80 -130 -32 -16 -59 -20 -150 -20 -134 0 -178 17 -210 80 -38 74 -16 153 56 196 35 21 51 24 152 24 93 0 120 -3 152 -20z m-800 -800 c45 -23 80 -80 80 -130 0 -50 -35 -107 -80 -130 -32 -16 -59 -20 -151 -20 -97 0 -116 3 -151 22 -101 57 -102 194 -2 254 35 21 51 24 152 24 93 0 120 -3 152 -20z m0 -800 c45 -23 80 -80 80 -130 0 -50 -35 -107 -80 -130 -32 -16 -59 -20 -151 -20 -97 0 -116 3 -151 22 -101 57 -102 194 -2 254 35 21 51 24 152 24 93 0 120 -3 152 -20z" />
                <path d="M950 3920 l0 -250 810 0 810 0 0 250 0 250 -810 0 -810 0 0 -250z" />
                <path d="M3480 2856 c-318 -50 -594 -189 -811 -408 -452 -455 -548 -1141 -238 -1703 70 -127 137 -215 253 -330 199 -198 438 -326 719 -387 146 -31 408 -31 553 0 139 30 241 65 364 127 396 199 677 565 772 1008 31 146 31 408 0 554 -62 288 -188 520 -397 728 -208 208 -462 344 -747 400 -112 22 -360 28 -468 11z m266 -602 c42 -20 73 -62 81 -108 5 -29 12 -36 61 -56 31 -13 77 -44 103 -69 61 -60 72 -110 37 -178 -44 -89 -135 -108 -228 -48 -102 65 -220 31 -220 -64 0 -27 72 -68 210 -122 58 -22 123 -51 146 -64 56 -33 121 -106 152 -173 24 -51 27 -69 27 -168 0 -107 -1 -112 -38 -186 -42 -86 -124 -170 -199 -206 -42 -19 -46 -24 -50 -65 -20 -178 -261 -182 -297 -6 -5 26 -14 33 -71 53 -178 62 -242 150 -191 262 14 31 30 47 63 63 60 29 81 27 167 -16 65 -32 84 -36 150 -37 64 -1 81 3 109 22 41 30 62 70 62 120 0 54 -32 83 -128 117 -108 38 -242 109 -297 157 -60 53 -91 108 -106 189 -29 159 47 320 189 401 42 24 52 35 52 56 0 40 41 103 80 123 43 23 91 24 136 3z" />
            </g>
        </svg>
    );

    const Invoice = (
        <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
                <path d="M944 4832 c-100 -35 -184 -117 -226 -220 l-23 -57 -3 -2075 -2 -2075 22 -45 c34 -66 79 -93 149 -88 59 4 66 9 509 314 l106 72 229 -165 c309 -223 310 -223 364 -223 26 0 58 7 73 14 15 8 115 92 223 186 l196 171 195 -171 c107 -95 207 -178 222 -186 15 -8 48 -14 73 -14 54 0 42 -8 366 224 122 87 224 158 228 159 4 0 131 -85 283 -189 265 -181 278 -188 331 -192 66 -4 111 20 145 78 l21 35 0 2085 0 2085 -23 57 c-29 71 -75 129 -137 174 -97 68 15 64 -1709 64 -1462 -1 -1564 -2 -1612 -18z m2553 -858 c98 -73 98 -195 0 -268 -28 -21 -31 -21 -937 -21 -906 0 -909 0 -937 21 -89 66 -99 179 -21 251 12 12 34 26 48 32 16 6 340 9 922 8 893 -2 897 -2 925 -23z m-17 -846 c66 -34 93 -79 88 -149 -5 -65 -32 -109 -82 -133 -31 -14 -124 -16 -926 -16 -802 0 -895 2 -926 16 -50 24 -77 68 -82 133 -5 70 22 115 88 149 l44 22 876 0 876 0 44 -22z m-840 -860 c48 -33 72 -70 77 -120 7 -58 -23 -118 -74 -149 l-38 -24 -460 -3 -460 -3 -45 23 c-66 34 -93 79 -88 149 5 64 31 108 80 132 29 15 91 17 504 17 l471 0 33 -22z" />
            </g>
        </svg>
    );

    const [apicall, setApicall] = useState(false);
    const [validated, setValidated] = useState(false);
    const [errors, setErrors] = useState([]);

    const initData = {
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        height_ft: "",
        height_in: "",
        wrist_to_floor: "",
        shoulder_to_wrist: "",
        elbow_to_wrist: ""
    };
    const [formData, setFormData] = useState(initData);
    const [remotefittingdata, setRemotefittingdata] = useState([]);
    const [remotefittingimage, setRemotefittingimage] = useState([]);

    const [dataNull, setDataNull] = useState(null)
    const [CheckModel, setCheckUpdateModel] = useState(false)
    const [selectedKeyword, setSelectedKeyword] = useState({});
    const [User_Id, setUser_Id] = useState('');
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [show, setShow] = useState(false);

    const [heightft, setHeightft] = useState('');
    const [heightin, setHeightin] = useState('');
    const [dexterity, setDexterity] = useState('');


    const dropdownStatusOptions = [
        {
            label: 'Fitted',
            icon: SettingIcon,
            value: '0',
        },
        {
            label: 'Contacted',
            icon: Contact,
            value: '1',
        },
        {
            label: 'Estimated',
            icon: Calculation,
            value: '2',
        },
        {
            label: 'Invoiced',
            icon: Invoice,
            value: '3',
        },
        {
            label: 'Purchase',
            icon: Calculator,
            value: '4',
        },
    ];


    function goBack() {
        window.history.back()
    }

    useEffect(() => {
        if (params.id !== undefined && params.id !== null) {
            getDataById();
            getremoteinquiryactivity();
        }
    }, [])

    const dataChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    }
    // const getDataById = async (event) => {
    //     getFittingById({ _id: params.id }, event).then((res) => {
    //         console.log("res", res);
    //         if (res?.code === 200) {
    //             const userData = res.data.data;
    //             setFormData(userData);
    //             setInitCustomerClub(JSON.parse(userData.initCustomerClub));
    //             setInitCustomerTesting(JSON.parse(userData.initCustomerTesting))
    //             setNotes(userData.notes)
    //             let fit = dropdownStatusOptions.find((item) => userData.followupStage === item.value)
    //             setSelectedKeyword(fit)
    //             setlastkeyword(fit);
    //             setDataNull(!null)
    //             setUser_Id(res.data.data.user_id)
    //         } else {
    //             alert(res.data?.message);
    //         }
    //     }).catch((err) => {
    //         alert(err);
    //     })
    // }

    const getDataById = async (event) => {
        getremoteInquirydataApi({ id: params.id }).then((res) => {
            console.log("aminesh ++", "10");
            console.log("res", res);
            if (res?.code === 200) {
                const userData = res.data.data;
                setFormData(userData);
                setHeightft(userData.height_ft);
                setHeightin(userData.height_in);
                setDexterity(userData.dexterity);
                let fit = dropdownStatusOptions.find((item) => userData.stage === item.value)
                setSelectedKeyword(fit)
                setlastkeyword(fit);
                setDataNull(!null)
                setUser_Id(res.data.data.user_id)
                setRemotefittingdata(userData.remotefittingdata);
                setRemotefittingimage(userData.remotefittingimage)
            } else {
                alert(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }

    const updateStageData = () => {
        setApicall(true);
        let event;
        const data = {
            id: params.id,
            stage: selectedKeyword.value,
            notes: stagenotes,
            user_id: userJson.user._id,
            last_stage: lastkeyword.label,
            update_state: selectedKeyword.label,
            notes: stagenotes
        };
        updateFittingStage(data, event).then((response) => {
            if (!response.data.status) {
                alert(response.data.message);
            } else {
                setApicall(false);
                handleShow();
                setCheckUpdateModel(null)
                getremoteinquiryactivity();
                setUpdatestageapicall(false);
            }
        }).catch((err) => {
            alert(err);
        }
        ).finally(() => {
            setApicall(false);
        });
        setValidated(true);
    };

    const updateFittingData = async (event) => {
        event.preventDefault();
        const data = {
            _id: params.id,
            initCustomerClub: JSON.stringify(initCustomerClub),
            initCustomerTesting: JSON.stringify(initCustomerTesting),
            notes: notes,
        };
        setApicall(true);
        updateFitting(data, event).then((res) => {
            console.log(res);
            if (!res.data.status) {
                setErrors(res.data.error);
                alert(JSON.stringify(res.data?.error[0].message));
            } else {
                setApicall(false);
                handleShow();
                setCheckUpdateModel(true)
                window.location.href = "/followups"
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicall(false);
        });
        setValidated(true);
    }


    const [lastkeyword, setlastkeyword] = useState(dropdownStatusOptions[0]);

    const handleKeywordSelect = (option) => {
        const selectedValue = option.value;
        setSelectedKeyword(option);
    };


    useEffect(() => {
        if (updatestageapicall == true) {
            updateStageData();
        }
    }, [updatestageapicall]);


    const handleUpdateSubmit = async (event) => {
        event.preventDefault();
        formData._id = User_Id;
        updateUser(formData, event).then((res) => {
            console.log(res);
            if (!res.data.status) {
                setErrors(res.data.error);
                alert(res.data.message);
            } else {
                getDataById()
                setApicall(false);
                handleShow();
            }
        }).catch((err) => {
            alert(err);
        }
        ).finally(() => {
            setApicall(false);
        });
        setValidated(true);
    }

    const getremoteinquiryactivity = () => {
        setApicall(true);
        const data = {
            id: params.id
        }
        getclubfollowactivityapi(data).then((response) => {
            if (!response.data.status) {
                setErrors(response.data.message);
                alert(response.data.message);
            } else {
                const data = response.data.data;
                setClubFollowActivity(data);
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicall(false);
            setValidated(true);
        });
    };

    const options1 = [
        { id: 1, text: 'Pull Hook' },
        { id: 2, text: 'Pull Straight' },
        { id: 3, text: 'Pull Fade' },
        { id: 4, text: 'Straight' },
        { id: 5, text: 'Push Draw' },
        { id: 6, text: 'Push Strait' },
        { id: 7, text: 'Push Slice' },
    ];

    const options2 = [
        { id: 1, text: 'Pull Hook' },
        { id: 2, text: 'Pull Straight' },
        { id: 3, text: 'Pull Fade' },
        { id: 4, text: 'Straight' },
        { id: 5, text: 'Push Draw' },
        { id: 6, text: 'Push Strait' },
        { id: 7, text: 'Push Slice' },
    ];

    const options3 = [
        { id: 1, text: 'Pull Hook' },
        { id: 2, text: 'Pull Straight' },
        { id: 3, text: 'Pull Fade' },
        { id: 4, text: 'Straight' },
        { id: 5, text: 'Push Draw' },
        { id: 6, text: 'Push Strait' },
        { id: 7, text: 'Push Slice' },
    ];
    
    const options4 =[
        { id: 1, text: '1' },
        { id: 2, text: '2' },
        { id: 3, text: '3' },
        { id: 4, text: '4' },
        { id: 5, text: '5' },
    ];

    const shotOpction = [
        { id: 1, text: 'On Target' },
        { id: 2, text: 'Left Of Target' },
        { id: 2, text: 'Right Of Target' },
    ]

    const shortStrike = [
        { id: 1, text: 'Tiger Strike' },
        { id: 2, text: 'No Tiger Strike' },
    ]


    const [currentStep, setCurrentStep] = useState(1);
    const [CheckcurrentStep, setCheckcurrentStep] = useState(0);

    const handlePrevStep = () => {
        setCurrentStep(currentStep - 1);
        window.scrollTo(0, 0);
    };

    const handleNextStep = () => {
        if (currentStep == 1) {
            setCurrentStep(currentStep + 1);
            setCheckcurrentStep(CheckcurrentStep + 1);
            window.scrollTo(0, 0);
        }
        if (currentStep == 2) {
            setCurrentStep(currentStep + 1);
            setCheckcurrentStep(CheckcurrentStep + 1);
            window.scrollTo(0, 0);
        }

        if (currentStep == 3) {
            setCurrentStep(currentStep + 1);
            setCheckcurrentStep(CheckcurrentStep + 1);
            window.scrollTo(0, 0);
        }

        if (currentStep == 4) {
            setCurrentStep(currentStep + 1);
            setCheckcurrentStep(CheckcurrentStep + 1);
            window.scrollTo(0, 0);
        }

        if (currentStep == 5) {
            setCurrentStep(currentStep + 1);
            setCheckcurrentStep(CheckcurrentStep + 1);
            window.scrollTo(0, 0);
        }

        if (currentStep == 6) {
            setCurrentStep(currentStep + 1);
            setCheckcurrentStep(CheckcurrentStep + 1);
            window.scrollTo(0, 0);
        }

        if (currentStep == 7) {
            setCurrentStep(currentStep + 1);
            setCheckcurrentStep(CheckcurrentStep + 1);
            window.scrollTo(0, 0);
        }

        if (currentStep == 8) {
            setCurrentStep(currentStep + 1);
            setCheckcurrentStep(CheckcurrentStep + 1);
            window.scrollTo(0, 0);
        }

        if (currentStep == 9) {
            setCurrentStep(currentStep + 1);
            setCheckcurrentStep(CheckcurrentStep + 1);
            window.scrollTo(0, 0);
        }

        if (currentStep == 10) {
            setCurrentStep(currentStep + 1);
            setCheckcurrentStep(CheckcurrentStep + 1);
            window.scrollTo(0, 0);
        }


    };

    const currentStepName = () => {
        switch (currentStep) {
            case 1:
                return "Get Started";
            case 2:
                return "Get Started";
            case 3:
                return "White Irons";
            case 4:
                return "Black Irons";
            case 5:
                return "Blue Irons";
            case 6:
                return "Pink Irons";
            case 7:
                return "Purple Irons";
            case 8:
                return "Red Irons";
            case 9:
                return "Orange Irons";
            case 10:
                return "Green Irons";

            default:
                return null;
        }
    };

    const nextStepName = () => {
        switch (currentStep + 1) {
            case 2:
                return "White Irons";
            case 3:
                return "Black Irons";
            case 4:
                return "Blue Irons";
            case 5:
                return "Pink Irons";
            case 6:
                return "Purple Irons";
            case 7:
                return "Red Irons";
            case 8:
                return "Orange Irons";
            case 9:
                return "Green Irons";
            case 10:
                return "Finish Up";
            case 11:
                return "Submit Fitting";

            default:
                return null;
        }
    };

    const renderStepContent = () => {
        switch (currentStep) {
            case 1:
                return (
                    <div className="step-content-item step-content-item-active w-100 step-1">
                        <div className="step">
                            <div class="sec-header-dash">
                                <div class="box-title mb-0" style={{ color: '#ffffff' }}>
                                    <h3>Getting Started</h3>
                                </div>
                            </div>
                            <div class="dashboard-sec">
                                <div className="bg_color_sec" style={{ display: 'none' }}>
                                    <div className="row align-items-center mb-5">
                                        <div className="col-md-6">
                                            <div class="box-step-content admin-box">
                                                <div class="box-title">
                                                    <h4>Watch this to get started</h4>
                                                </div>
                                                <div class="box-text">
                                                    <p>Before you start watch the video below to a get grasp on what you will be doing and how the process works.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div class="box-step-img">
                                                <img src={require('../../assets/images/bg-img.png')} alt="img" />
                                                <div className="play_icon">
                                                    <div className="play_icon_item">
                                                        <FaPlay />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="sec-header-dash">
                                {/* <div class="box-title mb-0" style={{ color: '#ffffff' }}>
                                    <h3>Your Info</h3>
                                </div>
                                <div class="content-box-btn">
                                    <button class="btn btn-add" onClick={handleedittrue}>Edit</button>
                                </div> */}
                            </div>
                            <div className="dashboard-sec">
                                <div className="container-fulid">
                                    {/* <Form noValidate validated={validated} onSubmit={handleUpdateSubmit}>
                                        <fieldset>
                                            <div className="form-box-section mt-4">
                                                <div className="form-box-inner">
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <label className="dashboard-form-lable">Name</label>
                                                            <input type="text"
                                                                required
                                                                className="form-control dashboard-input-box-3 me-1"
                                                                placeholder="First"
                                                                disabled={!edittrue}
                                                                value={formData.firstname}
                                                                name={"firstname"}
                                                                onChange={(e) => dataChange(e)}
                                                            />
                                                            <input type="text"
                                                                required
                                                                className="form-control dashboard-input-box-3 me-1"
                                                                placeholder="Last"
                                                                name={"lastname"}
                                                                disabled={!edittrue}
                                                                value={formData.lastname}
                                                                onChange={(e) => dataChange(e)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <Form.Label className="dashboard-form-lable">Email</Form.Label>
                                                            <div className="w-100">
                                                                <Form.Control
                                                                    type="email"
                                                                    className={`form-control dashboard-input-box-3 ${getErrorByField(errors, 'email').length > 0 ? 'is-invalid' : ''}`}
                                                                    placeholder="Email Address"
                                                                    name="email"
                                                                    disabled={!edittrue}
                                                                    value={formData.email}
                                                                    onChange={(e) => dataChange(e)}
                                                                />
                                                                <Form.Control.Feedback type="invalid">
                                                                    {
                                                                        errors.length > 0 ? getErrorByField(errors, "email").map((item) => {
                                                                            return item.detail;
                                                                        }) : "Please enter valid email"
                                                                    }
                                                                </Form.Control.Feedback>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <label className="dashboard-form-lable">Phone</label>
                                                            <div className="w-100">
                                                                <input type="number"
                                                                    name={"phone"}
                                                                    placeholder="Phone Number"
                                                                    required
                                                                    disabled={!edittrue}
                                                                    className={`form-control dashboard-input-box-3 ${getErrorByField(errors, 'phone_number').length > 0 ? 'is-invalid' : ''}`}
                                                                    value={formData.phone}
                                                                    onChange={(e) => dataChange(e)} />
                                                                <Form.Control.Feedback type="invalid">
                                                                    {
                                                                        errors.length > 0 ? getErrorByField(errors, "phone_number").map((item) => {
                                                                            return item.detail;
                                                                        }) : "Please enter valid phone number"
                                                                    }
                                                                </Form.Control.Feedback>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <label className="dashboard-form-lable">Height</label>
                                                            <div className="d-flex justify-content-end gap-2">
                                                                <input type="number" className="form-control dashboard-input-box w-30" disabled={!edittrue} name={"height_ft"} placeholder="ft." value={formData.height_ft} onChange={(e) => dataChange(e)} />
                                                                <input type="number" className="form-control dashboard-input-box w-30" disabled={!edittrue} name={"height_in"} placeholder="in." value={formData.height_in} onChange={(e) => dataChange(e)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </Form> */}

                                    <Form noValidate validated={validated} onSubmit={handleUpdateSubmit}>
                                        <div className="form-box-section follow-view-form mt-4">
                                            <div className="form-box-inner">
                                                <div className="form-item">
                                                    <div className="form-group custom-form-group">
                                                        <label className="dashboard-form-lable">Name</label>
                                                        <div className="followup-name-view">
                                                            <input type="text"
                                                                required
                                                                disabled
                                                                className={`form-control dashboard-input-box-2 me-1  ${errors.length > 0 ? getErrorByField(errors, "firstname").length > 0 ? "is-invalid" : "" : ""}`}
                                                                placeholder="First"
                                                                value={formData.firstname}
                                                                name={"firstname"}
                                                                onChange={(e) => dataChange(e)} />
                                                            <input type="text"
                                                                required
                                                                disabled
                                                                className={`form-control dashboard-input-box-2 ${errors.length > 0 ? getErrorByField(errors, "lastname").length > 0 ? "is-invalid" : "" : ""}`}
                                                                placeholder="Last"
                                                                name={"lastname"}
                                                                value={formData.lastname}
                                                                onChange={(e) => dataChange(e)} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-item">
                                                    <div className="form-group custom-form-group">
                                                        <Form.Label className="dashboard-form-lable">Email</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            className={`form-control dashboard-input-box-2 ${getErrorByField(errors, 'email').length > 0 ? 'is-invalid' : ''}`}
                                                            placeholder="Email Address"
                                                            name="email"
                                                            disabled
                                                            required
                                                            value={formData.email}
                                                            onChange={(e) => dataChange(e)} />
                                                        <Form.Control.Feedback type="invalid">
                                                            {
                                                                errors.length > 0 ? getErrorByField(errors, "email").map((item) => {
                                                                    return item.detail;
                                                                }) : "Please enter valid email"
                                                            }
                                                        </Form.Control.Feedback>
                                                    </div>
                                                </div>
                                                <div className="form-item">
                                                    <div className="form-group custom-form-group">
                                                        <label className="dashboard-form-lable">Phone</label>
                                                        <input type="text" name={"phone"}
                                                            disabled
                                                            className={`form-control dashboard-input-box-2 ${getErrorByField(errors, 'phone_number').length > 0 ? 'is-invalid' : ''}`}
                                                            placeholder="Phone Number" value={formData.phone} onChange={(e) => dataChange(e)} />
                                                        <Form.Control.Feedback type="invalid">
                                                            {
                                                                errors.length > 0 ? getErrorByField(errors, "phone_number").map((item) => {
                                                                    return item.detail;
                                                                }) : "Please enter phone number"
                                                            }
                                                        </Form.Control.Feedback>
                                                    </div>
                                                </div>
                                                {/* <div className="form-item">
                                                    <div className="form-group custom-form-group">
                                                        <label className="dashboard-form-lable">Height</label>
                                                        <div className="d-flex justify-content-end gap-2">
                                                            <input type="text" className="form-control dashboard-input-box w-30" name={"height_ft"} placeholder="ft." value={formData.height_ft} onChange={(e) => dataChange(e)} />
                                                            <input type="text" className="form-control dashboard-input-box w-30" name={"height_in"} placeholder="in." value={formData.height_in} onChange={(e) => dataChange(e)} />
                                                        </div>
                                                    </div>
                                                </div> */}
                                                <div className="form-item" style={{ display: 'none' }}>
                                                    <div className="form-group custom-form-group">
                                                        <label className="dashboard-form-lable">Wrist to Floor</label>
                                                        <input type="text" className="form-control dashboard-input-box w-18" name={"wrist_to_floor"} placeholder="in." value={formData.wrist_to_floor} onChange={(e) => dataChange(e)} />
                                                    </div>
                                                </div>
                                                <div className="form-item" style={{ display: 'none' }}>
                                                    <div className="form-group custom-form-group">
                                                        <label className="dashboard-form-lable">Shoulder to Wrist</label>
                                                        <input type="text" className="form-control dashboard-input-box w-18" name={"shoulder_to_wrist"} placeholder="in." value={formData.shoulder_to_wrist} onChange={(e) => dataChange(e)} />
                                                    </div>
                                                </div>
                                                <div className="form-item" style={{ display: 'none' }}>
                                                    <div className="form-group custom-form-group">
                                                        <label className="dashboard-form-lable">Elbow to Wrist</label>
                                                        <input type="text" className="form-control dashboard-input-box w-18" name={"elbow_to_wrist"} placeholder="in." value={formData.elbow_to_wrist} onChange={(e) => dataChange(e)} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <div className="sec-btn-group mt-4 update-sec">
                                            <Link to="/dashboard">
                                                <button className="btn btn-cancel">Exit without saving</button>
                                            </Link>
                                            {apicall ? (
                                                <button className="btn btn-save"><Spinner animation="border" className="border-black" /> </button>
                                            ) : (
                                                <button className="btn btn-save" type="submit">Update Profile</button>
                                            )}
                                        </div> */}
                                    </Form>
                                </div>
                            </div>
                            <div class="sec-header-dash">
                                <div class="box-title mb-0" style={{ color: '#ffffff' }}>
                                    <h3>Your Height</h3>
                                </div>
                            </div>
                            <div class="dashboard-sec">
                                <div className="form-box-section mt-4">
                                    <div className="form-item height-form-iteam">
                                        <div className="form-group custom-form-group mb-0">
                                            <label className="dashboard-form-lable">Height</label>
                                            <div className="d-flex justify-content-end gap-2 align-items-center w-100">
                                                {/* <input type="number" className="form-control dashboard-input-box w-30" disabled name={"height_ft"} placeholder="ft." value={formData.height_ft} onChange={(e) => dataChange(e)} />
                                                <label className="dashboard-form-lable me-0">ft.</label>
                                                <input type="number" className="form-control dashboard-input-box w-30" disabled name={"height_in"} placeholder="in." value={formData.height_in} onChange={(e) => dataChange(e)} />
                                                <label className="dashboard-form-lable me-0">in.</label> */}
                                                <select class="form-select form-control dashboard-input-box-3 select-custom-boxx w-25" disabled value={heightft} onChange={(e) => setHeightft(e.target.value)} aria-label="Default select example">
                                                    <option value={0}>ft.</option>
                                                    <option value="4">4 ft.</option>
                                                    <option value="5">5 ft.</option>
                                                    <option value="6">6 ft.</option>
                                                    <option value="7">7 ft.</option>
                                                </select>
                                                <select class="form-select form-control dashboard-input-box-3 select-custom-boxx w-25" disabled value={heightin} onChange={(e) => setHeightin(e.target.value)} aria-label="Default select example">
                                                    <option value={0}>in.</option>
                                                    <option value="1">0 in.</option>
                                                    <option value="2">1 in.</option>
                                                    <option value="3">2 in.</option>
                                                    <option value="4">3 in.</option>
                                                    <option value="5">4 in.</option>
                                                    <option value="6">5 in.</option>
                                                    <option value="7">6 in.</option>
                                                    <option value="8">7 in.</option>
                                                    <option value="9">8 in.</option>
                                                    <option value="10">9 in.</option>
                                                    <option value="11">10 in.</option>
                                                    <option value="12">11 in.</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="sec-header-dash">
                                <div class="box-title mb-0" style={{ color: '#ffffff' }}>
                                    <h3>Your Dexterity</h3>
                                </div>
                            </div>
                            <div class="dashboard-sec">
                                <div className="form-box-section mt-4">
                                    <div className="form-item height-form-iteam">
                                        <div className="form-group custom-form-group mb-0">
                                            <label className="dashboard-form-lable">Dexterity</label>
                                            <div className="d-flex justify-content-end gap-2 align-items-center w-100">
                                                {/* <input type="number" className="form-control dashboard-input-box w-30" disabled name={"height_ft"} placeholder="ft." value={formData.height_ft} onChange={(e) => dataChange(e)} />
                                                <label className="dashboard-form-lable me-0">ft.</label>
                                                <input type="number" className="form-control dashboard-input-box w-30" disabled name={"height_in"} placeholder="in." value={formData.height_in} onChange={(e) => dataChange(e)} />
                                                <label className="dashboard-form-lable me-0">in.</label> */}
                                                <select required class="form-select form-control dashboard-input-box-3 select-custom-boxx w-25" disabled={!edittrue} name={"dexterity"} value={formData.dexterity} onChange={(e) => dataChange(e)} aria-label="Default select example">
                                                    <option value={0}>Dexterity</option>
                                                    <option value="1">Right Handed</option>
                                                    <option value="2">Left Handed</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="sec-header-dash">
                                <div class="box-title mb-0" style={{ color: '#ffffff' }}>
                                    <h3>Your Swing</h3>
                                </div>
                            </div>
                            <div class="dashboard-sec" style={{ display: 'none' }}>
                                <div className="bg_color_sec">
                                    <div className="row align-items-center mb-5">
                                        <div className="col-md-6">
                                            <div class="box-step-content admin-box">
                                                <div class="box-title">
                                                    <h4>Film and send your swing</h4>
                                                </div>
                                                <div class="box-text">
                                                    <p>The first thing we need is videos of your swing. Watch the video below to ensure we are getting the right angles.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div class="box-step-img">
                                                <img src={require('../../assets/images/bg-img.png')} alt="img" />
                                                <div className="play_icon">
                                                    <div className="play_icon_item">
                                                        <FaPlay />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <Accordion>
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <Accordion.Item eventKey="0" className="mobile-accordion">
                                                    <div className="bg_green_light color_green_bg">
                                                        <div className="gs_fr_tops" id="lesson_card_1">
                                                            <Accordion.Header>
                                                                <div className="gab_title">
                                                                    <div className="gab_text bg-accordion-title">
                                                                        <h5>What camera do I use?</h5>
                                                                    </div>
                                                                    <div className="collapsed">
                                                                        <div className="">
                                                                            <FaAngleUp />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Accordion.Header>
                                                        </div>
                                                        <Accordion.Body className="box-accordion-body">
                                                            <div class="box-text admin-box box-accordion-p">
                                                                <p>Just use your cell phone! We don’t need slo mo videos. Just hold it vertically and film your angles.</p>
                                                            </div>
                                                        </Accordion.Body>
                                                    </div>
                                                </Accordion.Item>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <Accordion.Item eventKey="1" className="mobile-accordion">
                                                    <div className="bg_green_light color_green_bg">
                                                        <div className="gs_fr_tops" id="lesson_card_1">
                                                            <Accordion.Header>
                                                                <div className="gab_title">
                                                                    <div className="gab_text bg-accordion-title">
                                                                        <h5>What is the proper angle?</h5>
                                                                    </div>
                                                                    <div className="collapsed">
                                                                        <div className="">
                                                                            <FaAngleUp />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Accordion.Header>
                                                        </div>
                                                        <Accordion.Body className="box-accordion-body">
                                                            <div class="box-text admin-box box-accordion-p">
                                                                <p>Please watch the video above for directions. Camera is held at naval height from DTL and FO angles.</p>
                                                            </div>
                                                        </Accordion.Body>
                                                    </div>
                                                </Accordion.Item>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <Accordion.Item eventKey="2" className="mobile-accordion">
                                                    <div className="bg_green_light color_green_bg">
                                                        <div className="gs_fr_tops" id="lesson_card_1">
                                                            <Accordion.Header>
                                                                <div className="gab_title">
                                                                    <div className="gab_text bg-accordion-title">
                                                                        <h5>If it’s not your best swing?</h5>
                                                                    </div>
                                                                    <div className="collapsed">
                                                                        <div className="">
                                                                            <FaAngleUp />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Accordion.Header>
                                                        </div>
                                                        <Accordion.Body className="box-accordion-body">
                                                            <div class="box-text admin-box box-accordion-p">
                                                                <p>This isn’t the end of the world. We are looking at face to path ratios. We will see what we need to.</p>
                                                            </div>
                                                        </Accordion.Body>
                                                    </div>
                                                </Accordion.Item>
                                            </div>
                                        </div>
                                    </Accordion>
                                </div>
                            </div>
                            <div class="dashboard-sec">
                                <div className="bg_color_dark">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="d-flex justify-content-center gap-2">
                                                <VideoUpload step="step0" onfilechange={(editfile) => setFirstVideo(editfile)} remotefittingimage={remotefittingimage} />
                                                <VideoUpload2 step="step0" onfilechange={(editfile) => setSecondVideo(editfile)} remotefittingimage={remotefittingimage} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="sec-header-dash" style={{ display: 'none' }}>
                                <div class="box-title mb-0" style={{ color: '#ffffff' }}>
                                    <h3>Component Testing</h3>
                                </div>

                            </div>
                            <div class="dashboard-sec" style={{ display: 'none' }}>
                                <div className="bg_color_sec">
                                    <div className="row align-items-center mb-5">
                                        <div className="col-md-6">
                                            <div class="box-step-content admin-box">
                                                <div class="box-title">
                                                    <h4>Let’s start testing clubs</h4>
                                                </div>
                                                <div class="box-text">
                                                    <p>Its time to start testing irons. Watch the video below to get an overview of how to go through the process.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div class="box-step-img">
                                                <img src={require('../../assets/images/bg-img.png')} alt="img" />
                                                <div className="play_icon">
                                                    <div className="play_icon_item">
                                                        <FaPlay />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <Accordion>
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <Accordion.Item eventKey="0" className="mobile-accordion">
                                                    <div className="bg_green_light color_green_bg">
                                                        <div className="gs_fr_tops" id="lesson_card_1">
                                                            <Accordion.Header>
                                                                <div className="gab_title">
                                                                    <div className="gab_text bg-accordion-title">
                                                                        <h5>Do I need to go in order?</h5>
                                                                    </div>
                                                                    <div className="collapsed">
                                                                        <div className="">
                                                                            <FaAngleUp />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Accordion.Header>
                                                        </div>
                                                        <Accordion.Body className="box-accordion-body">
                                                            <div class="box-text admin-box box-accordion-p">
                                                                <p>Yes. The interface won’t allow you to skip any steps. We designed this process to work in order.</p>
                                                            </div>
                                                        </Accordion.Body>
                                                    </div>
                                                </Accordion.Item>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <Accordion.Item eventKey="1" className="mobile-accordion">
                                                    <div className="bg_green_light color_green_bg">
                                                        <div className="gs_fr_tops" id="lesson_card_1">
                                                            <Accordion.Header>
                                                                <div className="gab_title">
                                                                    <div className="gab_text bg-accordion-title">
                                                                        <h5>How to take strike photos?</h5>
                                                                    </div>
                                                                    <div className="collapsed">
                                                                        <div className="">
                                                                            <FaAngleUp />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Accordion.Header>
                                                        </div>
                                                        <Accordion.Body className="box-accordion-body">
                                                            <div class="box-text admin-box box-accordion-p">
                                                                <p>Watch the video! We just need all three sprayed clubs of the section laid down and photographed.</p>
                                                            </div>
                                                        </Accordion.Body>
                                                    </div>
                                                </Accordion.Item>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <Accordion.Item eventKey="2" className="mobile-accordion">
                                                    <div className="bg_green_light color_green_bg">
                                                        <div className="gs_fr_tops" id="lesson_card_1">
                                                            <Accordion.Header>
                                                                <div className="gab_title">
                                                                    <div className="gab_text bg-accordion-title">
                                                                        <h5>What is a preferred club?</h5>
                                                                    </div>
                                                                    <div className="collapsed">
                                                                        <div className="">
                                                                            <FaAngleUp />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Accordion.Header>
                                                        </div>
                                                        <Accordion.Body className="box-accordion-body">
                                                            <div class="box-text admin-box box-accordion-p">
                                                                <p>This is purely subjective. We want to know which option felt the best to you. No data, just feels.</p>
                                                            </div>
                                                        </Accordion.Body>
                                                    </div>
                                                </Accordion.Item>
                                            </div>
                                        </div>
                                    </Accordion>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            case 2:
                return (
                    <div className="step-content-item w-100 step-2">
                        <div className="sec-header-dash white">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>
                                    <span className="color"></span> White Irons
                                </h3>
                            </div>
                        </div>
                        <div>
                            <IronsData step="step1" iron="iron1" title="White Iron" number={'1'} options={options1} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                            <IronsData step="step1" iron="iron2" title="White Iron" number={'2'} options={options2} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                            <IronsData step="step1" iron="iron3" title="White Iron" number={'3'} options={options3} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                        </div>
                        <ImageUpload step="step1" remotefittingdata={remotefittingdata} remotefittingimage={remotefittingimage} title="White" />
                    </div>
                );
            case 3:
                return (
                    <div className="step-content-item black w-100 step-3">
                        <div className="sec-header-dash">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>
                                    <span className="color"></span> Black Irons
                                </h3>
                            </div>
                        </div>
                        <div>
                            <IronsData step="step2" iron="iron1" title="Black Iron" number={'1'} options={options1} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                            <IronsData step="step2" iron="iron2" title="Black Iron" number={'2'} options={options2} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                            <IronsData step="step2" iron="iron3" title="Black Iron" number={'3'} options={options3} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                        </div>
                        <ImageUpload step="step2" remotefittingdata={remotefittingdata} remotefittingimage={remotefittingimage} title="Black" />
                    </div>
                );
            case 4:
                return (
                    <div className="step-content-item blue w-100 step-4">
                        <div className="sec-header-dash">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>
                                    <span className="color"></span> Blue Irons
                                </h3>
                            </div>
                        </div>
                        <div>
                            <IronsData step="step3" iron="iron1" title="Blue Iron" number={'1'} options={options1} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                            <IronsData step="step3" iron="iron2" title="Blue Iron" number={'2'} options={options2} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                            <IronsData step="step3" iron="iron3" title="Blue Iron" number={'3'} options={options3} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                        </div>
                        <ImageUpload step="step3" remotefittingdata={remotefittingdata} remotefittingimage={remotefittingimage} title="Blue" />
                    </div>
                );
            case 5:
                return (
                    <div className="step-content-item pink w-100 step-5">
                        <div className="sec-header-dash">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>
                                    <span className="color"></span> Pink Irons
                                </h3>
                            </div>

                        </div>
                        <div>
                            <IronsData step="step4" iron="iron1" title="Pink Iron" number={'1'} options={options1} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                            <IronsData step="step4" iron="iron2" title="Pink Iron" number={'2'} options={options2} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                            <IronsData step="step4" iron="iron3" title="Pink Iron" number={'3'} options={options3} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                        </div>
                        <ImageUpload step="step4" remotefittingdata={remotefittingdata} remotefittingimage={remotefittingimage} title="Pink" />
                    </div>
                );
            case 6:
                return (
                    <div className="step-content-item purpal w-100 step-6">
                        <div className="sec-header-dash">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>
                                    <span className="color"></span> Purple Irons
                                </h3>
                            </div>
                        </div>
                        <div>
                            <IronsData step="step5" iron="iron1" title="Purple Iron" number={'1'} options={options1} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                            <IronsData step="step5" iron="iron2" title="Purple Iron" number={'2'} options={options2} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                            <IronsData step="step5" iron="iron3" title="Purple Iron" number={'3'} options={options3} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                        </div>
                        <ImageUpload step="step5" remotefittingdata={remotefittingdata} remotefittingimage={remotefittingimage} title="Purple" />
                    </div>
                );
            case 7:
                return (
                    <div className="step-content-item red w-100 step-7">
                        <div className="sec-header-dash">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>
                                    <span className="color"></span> Red Irons
                                </h3>
                            </div>

                        </div>
                        <div>
                            <IronsData step="step6" iron="iron1" title="Red Iron" number={'1'} options={options1} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                            <IronsData step="step6" iron="iron2" title="Red Iron" number={'2'} options={options2} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                            <IronsData step="step6" iron="iron3" title="Red Iron" number={'3'} options={options3} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                        </div>
                        <ImageUpload step="step6" remotefittingdata={remotefittingdata} remotefittingimage={remotefittingimage} title="Red" />
                    </div>
                );
            case 8:
                return (
                    <div className="step-content-item orange w-100 step-8">
                        <div className="sec-header-dash">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>
                                    <span className="color"></span> Orange Irons
                                </h3>
                            </div>

                        </div>
                        <div>
                            <IronsData step="step7" iron="iron1" title="Orange Iron" number={'1'} options={options1} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                            <IronsData step="step7" iron="iron2" title="Orange Iron" number={'2'} options={options2} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                            <IronsData step="step7" iron="iron3" title="Orange Iron" number={'3'} options={options3} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                        </div>
                        <ImageUpload step="step7" remotefittingdata={remotefittingdata} remotefittingimage={remotefittingimage} title="Orange" />
                    </div>
                );
            case 9:
                return (
                    <div className="step-content-item green w-100 step-8">
                        <div className="sec-header-dash">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>
                                    <span className="color"></span> Green Irons
                                </h3>
                            </div>

                        </div>
                        <div>
                            <IronsData step="step8" iron="iron1" title="Green Iron" number={'1'} options={options1} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                            <IronsData step="step8" iron="iron2" title="Green Iron" number={'2'} options={options2} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                            <IronsData step="step8" iron="iron3" title="Green Iron" number={'3'} options={options3} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                        </div>
                        <ImageUpload step="step8" remotefittingdata={remotefittingdata} remotefittingimage={remotefittingimage} title="Green" />
                    </div>
                );
            case 10:
                return (
                    <div className="step-content-item w-100 step-9">
                        <div class="sec-header-dash" style={{ display: 'none' }}>
                            <div class="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>Finishing Up</h3>
                            </div>
                        </div>
                        <div class="dashboard-sec" style={{ display: 'none' }}>
                            <div className="bg_color_sec">
                                <div className="row align-items-center mb-5">
                                    <div className="col-md-6">
                                        <div class="box-step-content admin-box">
                                            <div class="box-title">
                                                <h4>What happens now?</h4>
                                            </div>
                                            <div class="box-text">
                                                <p>Before you submit your fitting leave us some notes below. Once you submit this our team will be in contact.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div class="box-step-img">
                                            <img src={require('../../assets/images/bg-img.png')} alt="img" />
                                            <div className="play_icon">
                                                <div className="play_icon_item">
                                                    <FaPlay />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Accordion>
                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <Accordion.Item eventKey="0" className="mobile-accordion">
                                                <div className="bg_green_light color_green_bg">
                                                    <div className="gs_fr_tops" id="lesson_card_1">
                                                        <Accordion.Header>
                                                            <div className="gab_title">
                                                                <div className="gab_text bg-accordion-title">
                                                                    <h5>What are the notes for?</h5>
                                                                </div>
                                                                <div className="collapsed">
                                                                    <div className="">
                                                                        <FaAngleUp />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Accordion.Header>
                                                    </div>
                                                    <Accordion.Body className="box-accordion-body">
                                                        <div class="box-text admin-box box-accordion-p">
                                                            <p>We want to understand what you thought and felt during testing. Whatever it is leave it for us!</p>
                                                        </div>
                                                    </Accordion.Body>
                                                </div>
                                            </Accordion.Item>
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <Accordion.Item eventKey="1" className="mobile-accordion">
                                                <div className="bg_green_light color_green_bg">
                                                    <div className="gs_fr_tops" id="lesson_card_1">
                                                        <Accordion.Header>
                                                            <div className="gab_title">
                                                                <div className="gab_text bg-accordion-title">
                                                                    <h5>What happens after this?</h5>
                                                                </div>
                                                                <div className="collapsed">
                                                                    <div className="">
                                                                        <FaAngleUp />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Accordion.Header>
                                                    </div>
                                                    <Accordion.Body className="box-accordion-body">
                                                        <div class="box-text admin-box box-accordion-p">
                                                            <p>We are going to talk. We will reach our via email to dial you in and get you your prescription.</p>
                                                        </div>
                                                    </Accordion.Body>
                                                </div>
                                            </Accordion.Item>
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <Accordion.Item eventKey="2" className="mobile-accordion">
                                                <div className="bg_green_light color_green_bg">
                                                    <div className="gs_fr_tops" id="lesson_card_1">
                                                        <Accordion.Header>
                                                            <div className="gab_title">
                                                                <div className="gab_text bg-accordion-title">
                                                                    <h5>What will you receive?</h5>
                                                                </div>
                                                                <div className="collapsed">
                                                                    <div className="">
                                                                        <FaAngleUp />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Accordion.Header>
                                                    </div>
                                                    <Accordion.Body className="box-accordion-body">
                                                        <div class="box-text admin-box box-accordion-p">
                                                            <p>You will get a full prescription of what we would build you. No loyalty to any brand, not even ours.</p>
                                                        </div>
                                                    </Accordion.Body>
                                                </div>
                                            </Accordion.Item>
                                        </div>
                                    </div>
                                </Accordion>
                            </div>
                        </div>
                        <div class="sec-header-dash">
                            <div class="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>Your Notes</h3>
                            </div>
                        </div>

                        <div className="dashboard-sec">
                            <div className="form-box-section mb-3">
                                <textarea className="dashboard-text-area" disabled id="exampleFormControlTextarea1" rows="8" value={remotefittingdata.step9.notes} placeholder="Leave your note here..."></textarea>
                            </div>
                        </div>
                        {/* <buton className="btn btn-colr-white active mt-3 mb-3 d-flex justify-content-center align-items-center btn-fitting-submit" onClick={() => updateremotefittingdata()}>{apicall ? (<Spinner animation="border" className="border-black" />) : (<span>Submit Your Fitting</span>)}</buton> */}
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <>
            <Modal
                show={show} // Show the modal when `show` is true
                onHide={handleClose}
                centered
                id="success_tic"
                className='model-thank-you'
            >
                <Modal.Body>
                    <div className="logo-modal mb-4 text-center">
                        <img src={require('../../assets/images/logo_text.png')} alt="logo" />
                    </div>
                    <h3 className="text-center">
                        {CheckModel == false && ("User update successfully")}
                        {CheckModel == true && ("Fitting update successfully")}
                        {CheckModel === null && "Stage update successfully"}
                    </h3>
                </Modal.Body>
            </Modal>
            <div>
                <div className="main-page-body-content-header">
                    <HeaderAdmin />
                </div>
                <div className="dashboard-container d-flex">
                    <div className="main-container">
                        <div className="main-page-body-content">
                            <div className="main-page-body-content-body">
                                <div className="main-page-body-content-body-container">
                                    <div className="mobile-section show_mobile">
                                        <div className="container-fluid">
                                            <div className="row">
                                                <div className="button-section">
                                                    <div className="d-flex align-items-center gap-3">
                                                        <div className="back-btn w-100">
                                                            {/* {
                                                                userJson && userJson.user?.role_id !== 4 ? <button className="btn back-btn-color w-100" onClick={goBack}>
                                                                    <i className="arrow-left" aria-hidden="true"><IoIosArrowBack /></i> Follow Ups
                                                                </button> : <></>
                                                            } */}

                                                            {
                                                                roleId && roleId != 4 ? (
                                                                    <button className="btn back-btn-color w-100" onClick={goBack}>
                                                                        <i className="arrow-left" aria-hidden="true"><IoIosArrowBack /></i> Follow Ups
                                                                    </button>
                                                                ) : null
                                                            }



                                                        </div>
                                                        {
                                                            roleId && roleId != 4 && (
                                                                <div className={`custom-select activity_select w-100 ${isOpen ? 'open' : ''}`}>
                                                                    <div className="selected-option-drop justify-content-center" onClick={toggleDropdown}>
                                                                        <span className="selected-option-text xt094">Activity</span>
                                                                        <span className={`icon ${isOpen ? 'up' : 'down'}`}>
                                                                            <i className="bi bi-chevron-down" />
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                    {isOpen && roleId && roleId != 4 && (
                                                        <div className="activity-mobile-details">
                                                            <div className="col-lg-12">
                                                                <div className="d-flex justify-content-between align-items-center gap-4">
                                                                    <div className="middle-heading mb-0" style={{ color: '#ffffff' }}>
                                                                        <h3>Activity</h3>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="dashboard-sec">
                                                                <Swiper
                                                                    modules={[Scrollbar, Mousewheel]}
                                                                    spaceBetween={10}
                                                                    slidesPerView="auto"
                                                                    freeMode={true}
                                                                    onSlideChange={() => console.log('slide change')}
                                                                    onSwiper={(swiper) => console.log(swiper)}
                                                                    // centeredSlides={true}
                                                                    mousewheel={{ forceToAxis: true }}
                                                                    breakpoints={{
                                                                        500: {
                                                                            slidesPerView: 1,
                                                                            spaceBetween: 10
                                                                        },
                                                                        640: {
                                                                            slidesPerView: 2,
                                                                            spaceBetween: 10
                                                                        },
                                                                        768: {
                                                                            slidesPerView: 2,
                                                                            spaceBetween: 30
                                                                        },
                                                                        992: {
                                                                            slidesPerView: 3,
                                                                            spaceBetween: 30
                                                                        },
                                                                    }}
                                                                    className="our_process_slider"
                                                                >
                                                                    {
                                                                        clubfollowactivity && clubfollowactivity.map((item, index) => (
                                                                            <SwiperSlide className="" key={index}>
                                                                                <div className="form-box-section mt-4">
                                                                                    <div className="form-list-inner">
                                                                                        <div className="form-list-title activity-title">
                                                                                            <div className="emp-name">
                                                                                                <div className="emp-light">Employee:</div>
                                                                                                <div className="emp-bold">{item.firstname + " " + item.lastname}</div>
                                                                                            </div>
                                                                                            <div className="emp-status">
                                                                                                <div className="emp-light">Status:</div>
                                                                                                <div className="emp-bold">{item.what_change}</div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="form-card-body-status">
                                                                                            {item.notes}
                                                                                        </div>
                                                                                        <div className="form-change-date">Date: <span className="emp-bold">{item && formatDate(item.createdAt)}</span></div>
                                                                                    </div>
                                                                                </div>
                                                                            </SwiperSlide>
                                                                        ))
                                                                    }
                                                                </Swiper>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                {
                                                    roleId && roleId != 4 && (
                                                        <div className="col-lg-12">
                                                            <div className="drop-down">
                                                                <CustomSelectIcon
                                                                    options={dropdownStatusOptions}
                                                                    defaultSelected={selectedKeyword}
                                                                    onSelect={handleKeywordSelect}
                                                                    ontextchange={(text) => { setStageNotes(text) }}
                                                                    onpopclose={(activity) => { setUpdatestageapicall(activity) }}
                                                                />
                                                            </div>
                                                        </div>
                                                    )
                                                }

                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-7 col-lg-8 col-xl-9">
                                            <div className="container-fluid">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <div className="back-btn hide_mobile">
                                                            {
                                                                roleId && roleId != 4 ? (
                                                                    <button className="btn back-btn-color" onClick={goBack}>
                                                                        <i className="arrow-left" aria-hidden="true"><IoIosArrowBack /></i> Fitting Follow Ups
                                                                    </button>
                                                                ) : null
                                                            }
                                                            {/* <button className="btn back-btn-color" onClick={goBack}>
                                                                <i className="arrow-left" aria-hidden="true"><IoIosArrowBack /></i> Fitting Follow Ups
                                                            </button> */}
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="dashboard-sec">
                                                <div className="container-fluid">
                                                    <Form noValidat style={{ display: 'none' }} validated={validated} onSubmit={handleUpdateSubmit}>
                                                        <div className="form-box-section mt-4">
                                                            <div className="form-box-inner">
                                                                <div className="form-item">
                                                                    <div className="form-group custom-form-group">
                                                                        <label className="dashboard-form-lable">Name</label>
                                                                        <input type="text"
                                                                            required
                                                                            className={`form-control dashboard-input-box-1 me-1  ${errors.length > 0 ? getErrorByField(errors, "firstname").length > 0 ? "is-invalid" : "" : ""}`}
                                                                            placeholder="First"
                                                                            value={formData.firstname}
                                                                            name={"firstname"}
                                                                            onChange={(e) => dataChange(e)} />
                                                                        <input type="text"
                                                                            required
                                                                            className={`form-control dashboard-input-box-1 ${errors.length > 0 ? getErrorByField(errors, "lastname").length > 0 ? "is-invalid" : "" : ""}`}
                                                                            placeholder="Last"
                                                                            name={"lastname"}
                                                                            value={formData.lastname}
                                                                            onChange={(e) => dataChange(e)} />
                                                                    </div>
                                                                </div>
                                                                <div className="form-item">
                                                                    <div className="form-group custom-form-group">
                                                                        <Form.Label className="dashboard-form-lable">Email</Form.Label>
                                                                        <Form.Control
                                                                            type="text"
                                                                            className={`form-control dashboard-input-box-2 ${getErrorByField(errors, 'email').length > 0 ? 'is-invalid' : ''}`}
                                                                            placeholder="Email Address"
                                                                            name="email"
                                                                            required
                                                                            value={formData.email}
                                                                            onChange={(e) => dataChange(e)} />
                                                                        <Form.Control.Feedback type="invalid">
                                                                            {
                                                                                errors.length > 0 ? getErrorByField(errors, "email").map((item) => {
                                                                                    return item.message;
                                                                                }) : "Please enter valid email"
                                                                            }
                                                                        </Form.Control.Feedback>
                                                                    </div>
                                                                </div>
                                                                <div className="form-item">
                                                                    <div className="form-group custom-form-group">
                                                                        <label className="dashboard-form-lable">Phone</label>
                                                                        <input type="text" name={"phone"}
                                                                            className={`form-control dashboard-input-box-2 ${getErrorByField(errors, 'phone_number').length > 0 ? 'is-invalid' : ''}`}
                                                                            placeholder="Phone Number" value={formData.phone} onChange={(e) => dataChange(e)} />
                                                                        <Form.Control.Feedback type="invalid">
                                                                            {
                                                                                errors.length > 0 ? getErrorByField(errors, "phone_number").map((item) => {
                                                                                    return item.detail;
                                                                                }) : "Please enter phone number"
                                                                            }
                                                                        </Form.Control.Feedback>
                                                                    </div>
                                                                </div>
                                                                <div className="form-item">
                                                                    <div className="form-group custom-form-group">
                                                                        <label className="dashboard-form-lable">Height</label>
                                                                        <div className="d-flex justify-content-end gap-2">
                                                                            <input type="text" className="form-control dashboard-input-box w-30" name={"height_ft"} placeholder="0" value={formData.height_ft} onChange={(e) => dataChange(e)} />
                                                                            <input type="text" className="form-control dashboard-input-box w-30" name={"height_in"} placeholder="0" value={formData.height_in} onChange={(e) => dataChange(e)} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="form-item">
                                                                    <div className="form-group custom-form-group">
                                                                        <label className="dashboard-form-lable">Wrist to Floor</label>
                                                                        <input type="text" className="form-control dashboard-input-box w-18" name={"wrist_to_floor"} placeholder="in." value={formData.wrist_to_floor} onChange={(e) => dataChange(e)} />
                                                                    </div>
                                                                </div>
                                                                <div className="form-item">
                                                                    <div className="form-group custom-form-group">
                                                                        <label className="dashboard-form-lable">Shoulder to Wrist</label>
                                                                        <input type="text" className="form-control dashboard-input-box w-18" name={"shoulder_to_wrist"} placeholder="in." value={formData.shoulder_to_wrist} onChange={(e) => dataChange(e)} />
                                                                    </div>
                                                                </div>
                                                                <div className="form-item">
                                                                    <div className="form-group custom-form-group">
                                                                        <label className="dashboard-form-lable">Elbow to Wrist</label>
                                                                        <input type="text" className="form-control dashboard-input-box w-18" name={"elbow_to_wrist"} placeholder="in." value={formData.elbow_to_wrist} onChange={(e) => dataChange(e)} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="sec-btn-group mt-4 update-sec">
                                                            <Link to="/dashboard">
                                                                <button className="btn btn-cancel">Exit without saving</button>
                                                            </Link>
                                                            {apicall ? (
                                                                <button className="btn btn-save"><Spinner animation="border" className="border-black" /> </button>
                                                            ) : (
                                                                <button className="btn btn-save" type="submit">Update Profile</button>
                                                            )}
                                                        </div>
                                                    </Form>
                                                    {dataNull === null ? "" :
                                                        <>

                                                            <div className="step-btn follow-view-step-btn">
                                                                <div className="step-btn-item">
                                                                    <button
                                                                        className="btn step-btn-view step-left-btn"
                                                                        onClick={handlePrevStep}
                                                                        disabled={currentStep === 1}
                                                                    >
                                                                        {currentStep !== 1 && <FaChevronLeft />}
                                                                        <div className="pr_content m-0 step_pr_content">
                                                                            <h6>Step {currentStep - +1}</h6>
                                                                            <h4>{currentStepName()}</h4>
                                                                        </div>
                                                                    </button>
                                                                </div>
                                                                <div className="step-btn-item">
                                                                    {currentStep === 1 && apicall ? (
                                                                        <button
                                                                            className="btn step-btn-view step-right-btn"
                                                                        >
                                                                            <Spinner animation="border" className="border-white" />
                                                                        </button>

                                                                    ) : (
                                                                        <button
                                                                            className="btn step-btn-view step-right-btn"
                                                                            onClick={handleNextStep}
                                                                            disabled={currentStep === 10}
                                                                        >
                                                                            <div className="pr_content m-0 step_pr_content text-right">
                                                                                <h6>Step {currentStep + 1}</h6>
                                                                                <h4>{nextStepName()}</h4>
                                                                            </div>
                                                                            {currentStep !== 10 && <FaChevronRight />}
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="step-content follow-view-step-content">{renderStepContent()}</div>
                                                            <div className="step-btn follow-view-step-btn">
                                                                <div className="step-btn-item">
                                                                    <button
                                                                        className="btn step-btn-view step-left-btn"
                                                                        onClick={handlePrevStep}
                                                                        disabled={currentStep === 1}
                                                                    >
                                                                        {currentStep !== 1 && <FaChevronLeft />}
                                                                        <div className="pr_content m-0 step_pr_content">
                                                                            <h6>Step {currentStep - +1}</h6>
                                                                            <h4>{currentStepName()}</h4>
                                                                        </div>
                                                                    </button>
                                                                </div>
                                                                <div className="step-btn-item">
                                                                    {currentStep === 1 && apicall ? (
                                                                        <button
                                                                            className="btn step-btn-view step-right-btn"
                                                                        >
                                                                            <Spinner animation="border" className="border-white" />
                                                                        </button>

                                                                    ) : (
                                                                        <button
                                                                            className="btn step-btn-view step-right-btn"
                                                                            onClick={handleNextStep}
                                                                            disabled={currentStep === 10}
                                                                        >
                                                                            <div className="pr_content m-0 step_pr_content text-right">
                                                                                <h6>Step {currentStep + 1}</h6>
                                                                                <h4>{nextStepName()}</h4>
                                                                            </div>
                                                                            {currentStep !== 10 && <FaChevronRight />}
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </>
                                                    }
                                                </div>

                                            </div>
                                        </div>
                                        <div className="col-md-5 col-lg-4 col-xl-3 hide_mobile fix-col">
                                            {
                                                roleId && roleId != 4 && (
                                                    <div className="container-fluid ps-0">
                                                        <div className="drop-down">
                                                            <CustomSelectIcon
                                                                options={dropdownStatusOptions}
                                                                defaultSelected={selectedKeyword}
                                                                onSelect={handleKeywordSelect}
                                                                ontextchange={(text) => { setStageNotes(text) }}
                                                                onpopclose={(activity) => { setUpdatestageapicall(activity) }}
                                                            />
                                                        </div>
                                                        <div className="col-lg-12">
                                                            <div className="d-flex justify-content-between align-items-center gap-4">
                                                                <div className="middle-heading mb-0" style={{ color: '#ffffff' }}>
                                                                    <h3>Activity</h3>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="dashboard-sec fix-activity">
                                                            {
                                                                clubfollowactivity && clubfollowactivity.map((item, index) => (
                                                                    <div className="form-box-section activity-form-box">
                                                                        <div className="form-list-inner">
                                                                            <div className="form-list-title activity-title">
                                                                                <div className="emp-name">
                                                                                    <div className="emp-light">Employee:</div>
                                                                                    <div className="emp-bold">{item.firstname + " " + item.lastname}</div>
                                                                                </div>
                                                                                <div className="emp-status">
                                                                                    <div className="emp-light">Status:</div>
                                                                                    <div className="emp-bold">{item.what_change}</div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-card-body-status">
                                                                                {item.notes}
                                                                            </div>
                                                                            <div className="form-change-date">Date: <span className="emp-bold">{item && formatDate(item.createdAt)}</span></div>
                                                                        </div>
                                                                    </div>
                                                                ))
                                                            }
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
}

function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');

    return `${month}/${day}/${year}`;
}

export default FollowView;